/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ../../node/read-file-sync.node (ignored)
// module id = 1759
// module chunks = 0